module.exports = __webpack_public_path__ + "static/media/user-alt.168df2a6.svg";